export const lang =
    [
        {
            "field1": "",
            "ID": "ID",
            "zh-CN": "中文",
            "field4": "位置",
            "field5": "字节限制",
            "en": "英文",
            "ja": "日语",
            "ko": "韩语",
            "ru": "俄语",
            "zh-TW": "繁体中文"
        },
        {
            "field1": "",
            "ID": "1",
            "zh-CN": "礼包码兑换",
            "field4": "标题图片",
            "field5": "15",
            "en": "Rewards Page",
            "ja": "報酬ページ",
            "ko": "기프트코드 교환",
            "ru": "Страница наград",
            "zh-TW": "禮包兌換"
        },
        {
            "field1": "",
            "ID": "2",
            "zh-CN": "游戏ID",
            "field4": "输入框",
            "field5": "15",
            "en": "Game ID",
            "ja": "ゲームID",
            "ko": "게임ID",
            "ru": "ID игрока",
            "zh-TW": "遊戲ID"
        },
        {
            "field1": "",
            "ID": "3",
            "zh-CN": "如何找到ID？",
            "field4": "输入框",
            "field5": "25",
            "en": "How to find your Game ID",
            "ja": "ゲームIDの確認方法",
            "ko": "게임ID 찾는 방법",
            "ru": "Как найти свой ID игрока",
            "zh-TW": "如何找到ID？"
        },
        {
            "field1": "",
            "ID": "4",
            "zh-CN": "请输入您的ID",
            "field4": "输入框",
            "field5": "25",
            "en": "Enter your Game ID here",
            "ja": "ここにゲームIDを入力してください",
            "ko": "게임ID를 입력하세요",
            "ru": "Введите ID игрока",
            "zh-TW": "請輸入您的ID"
        },
        {
            "field1": "",
            "ID": "5",
            "zh-CN": "兑换码",
            "field4": "输入框",
            "field5": "15",
            "en": "Rewards Code",
            "ja": "報酬コード",
            "ko": "기프트코드",
            "ru": "Наградной код",
            "zh-TW": "兌換碼"
        },
        {
            "field1": "",
            "ID": "6",
            "zh-CN": "请输入您的兑换码",
            "field4": "输入框",
            "field5": "25",
            "en": "Enter Rewards Code here",
            "ja": "ここに報酬コードを入力してください",
            "ko": "기프트코드를 입력하세요",
            "ru": "Введите наградной код",
            "zh-TW": "請輸入您的兌換碼"
        },
        {
            "field1": "",
            "ID": "7",
            "zh-CN": "验证码",
            "field4": "输入框",
            "field5": "20",
            "en": "Verification Code",
            "ja": "確認コード",
            "ko": "확인 코드",
            "ru": "Код подтверждения",
            "zh-TW": "驗證碼"
        },
        {
            "field1": "",
            "ID": "8",
            "zh-CN": "点击图片刷新验证码",
            "field4": "输入框",
            "field5": "35",
            "en": "To refresh the code, tap the image",
            "ja": "コードを更新するには、画像をタップしてください",
            "ko": "확인 코드를 새로 고침하려면 이미지를 탭하세요",
            "ru": "Обновите код, нажав картинку",
            "zh-TW": "點擊圖片刷新驗證碼"
        },
        {
            "field1": "",
            "ID": "9",
            "zh-CN": "领取奖励",
            "field4": "按钮图片",
            "field5": "10",
            "en": "Redeem",
            "ja": "交換",
            "ko": "교환",
            "ru": "Обменять",
            "zh-TW": "兌換獎勵"
        },
        {
            "field1": "",
            "ID": "10",
            "zh-CN": "同一兑换码仅供每个帐号使用1次，无法重复使用",
            "field4": "说明",
            "field5": "70",
            "en": "Each Rewards Code can only be used once per account.",
            "ja": "各報酬コードの使用回数はアカウントにつき1回限りです",
            "ko": "동일한 사용 코드는 계정당 한 번만 사용할 수 있습니다.",
            "ru": "Наградной код можно использовать только один раз для учетной записи.",
            "zh-TW": "同一兌換碼僅供每個帳號使用1次，無法重複使用"
        },
        {
            "field1": "",
            "ID": "11",
            "zh-CN": "1. 打开游戏设置界面",
            "field4": "说明",
            "field5": "30",
            "en": "1. Go to Settings",
            "ja": "1. [設定] にアクセスします",
            "ko": "1. 게임 내 설정으로 이동하세요",
            "ru": "1. Откройте настройки.",
            "zh-TW": "1. 打開遊戲設置界面"
        },
        {
            "field1": "",
            "ID": "12",
            "zh-CN": "2. 记录下您的ID",
            "field4": "说明",
            "field5": "30",
            "en": "2. Find your Game ID",
            "ja": "2. ゲームIDを検索します",
            "ko": "2. 게임ID를 찾으세요",
            "ru": "2. Найдите свой ID игрока.",
            "zh-TW": "2. 記錄下您的ID"
        },
        {
            "field1": "",
            "ID": "13",
            "zh-CN": "留下邮箱地址，领取额外兑换码",
            "field4": "输入框",
            "field5": "45",
            "en": "Leave your Email to surprise Reward Codes!",
            "ja": "メールアドレスを入力して追加の報酬コードをゲットしよう！",
            "ko": "이메일 주소를 남기고 추가 기프트코드를 받으세요",
            "ru": "Укажите эл. адрес для наградных кодов!",
            "zh-TW": "留下郵箱地址，領取額外兌換碼獎勵"
        },
        {
            "field1": "",
            "ID": "14",
            "zh-CN": "邮箱：",
            "field4": "输入框",
            "field5": "10",
            "en": "Email:",
            "ja": "メールアドレス：",
            "ko": "이메일:",
            "ru": "Эл. почта:",
            "zh-TW": "郵箱："
        },
        {
            "field1": "",
            "ID": "15",
            "zh-CN": "请输入您的邮箱地址",
            "field4": "输入框",
            "field5": "35",
            "en": "Enter your Email Address",
            "ja": "メールアドレスを入力します",
            "ko": "이메일 주소를 입력하세요",
            "ru": "Введите адрес эл. почты",
            "zh-TW": "請輸入您的郵箱地址"
        },
        {
            "field1": "",
            "ID": "16",
            "zh-CN": "ID：",
            "field4": "弹窗",
            "field5": "10",
            "en": "ID:",
            "ja": "ID：",
            "ko": "ID:",
            "ru": "ID:",
            "zh-TW": "ID："
        },
        {
            "field1": "",
            "ID": "17",
            "zh-CN": "您确认为此ID兑换奖励吗？",
            "field4": "弹窗",
            "field5": "50",
            "en": "Confirm redeeming the code for this ID?",
            "ja": "このIDに対してコードの交換を確定しますか？",
            "ko": "이 ID를 사용하여 코드를 교환하시겠습니까?",
            "ru": "Использовать код для этого ID?",
            "zh-TW": "您確認為此ID兌換獎勵嗎？"
        },
        {
            "field1": "",
            "ID": "18",
            "zh-CN": "是",
            "field4": "弹窗按钮",
            "field5": "10",
            "en": "Yes!",
            "ja": "はい！",
            "ko": "네",
            "ru": "Да!",
            "zh-TW": "是"
        },
        {
            "field1": "",
            "ID": "19",
            "zh-CN": "否",
            "field4": "弹窗按钮",
            "field5": "10",
            "en": "No, wait.",
            "ja": "いいえ",
            "ko": "아니오",
            "ru": "Нет…",
            "zh-TW": "否"
        },
        {
            "field1": "",
            "ID": "20",
            "zh-CN": "恭喜您兑换成功！奖励已发送到您游戏中的邮箱，请及时查收！",
            "field4": "弹窗",
            "field5": "100",
            "en": "Congratulations! Your rewards have been sent to your in-game Mailbox. Go and check it out!",
            "ja": "おめでとうございます！報酬がゲーム内のメールボックスに送信されました。早速チェックしよう！",
            "ko": "축하합니다! 보상은 게임 내 우편함으로 발송되었으니 확인하세요!",
            "ru": "Поздравляем! Награды отправлены вам игровой почтой. Взгляните!",
            "zh-TW": "恭喜您兌換成功！獎勵已發送到您遊戲中的郵箱，請及時查收！"
        },
        {
            "field1": "",
            "ID": "21",
            "zh-CN": "兑换失败！您的ID错误，请确认",
            "field4": "弹窗",
            "field5": "80",
            "en": "Oh no, we suspect your ID is incorrect. Please check again.",
            "ja": "IDが誤っているようです。もう一度ご確認ください。",
            "ko": "교환 실패! ID가 틀린 것 같습니다. 다시 확인해주세요.",
            "ru": "О нет, вероятно, вы указали неверный ID. Проверьте его.",
            "zh-TW": "兌換失敗！您的ID錯誤，請確認"
        },
        {
            "field1": "",
            "ID": "22",
            "zh-CN": "兑换失败！您的兑换码错误，请确认",
            "field4": "弹窗",
            "field5": "80",
            "en": "Oh no, we suspect your Rewards Code is incorrect. Please check again.",
            "ja": "報酬コードが誤っているようです。もう一度ご確認ください。",
            "ko": "교환 실패! 기프트코드가 틀린 것 같습니다. 다시 확인해주세요.",
            "ru": "О нет, вероятно, вы указали неверный наградной код. Проверьте его.",
            "zh-TW": "兌換失敗！您的兌換碼錯誤，請確認"
        },
        {
            "field1": "",
            "ID": "23",
            "zh-CN": "兑换失败！您的兑换码已使用，无法再次兑换奖励",
            "field4": "弹窗",
            "field5": "80",
            "en": "Oh no, your Rewards Code has already been used!",
            "ja": "報酬コードがすでに使用されています！",
            "ko": "교환 실패! 기프트코드를 이미 사용했습니다. 재사용할 수 없습니다.",
            "ru": "О нет, вероятно, этот наградной код уже использован!",
            "zh-TW": "兌換失敗！您的兌換碼已使用，無法再次兌換獎勵"
        },
        {
            "field1": "",
            "ID": "24",
            "zh-CN": "兑换失败！您的兑换码已过期，无法兑换奖励",
            "field4": "弹窗",
            "field5": "80",
            "en": "Oh no, your Rewards Code has expired...",
            "ja": "報酬コードが期限切れです…",
            "ko": "교환 실패! 기프트코드가 만료되었습니다.",
            "ru": "О нет, этот игровой код просрочен!",
            "zh-TW": "兌換失敗！您的兌換碼已過期，無法兌換獎勵"
        },
        {
            "field1": "",
            "ID": "25",
            "zh-CN": "请输入ID",
            "field4": "错误提示",
            "field5": "35",
            "en": "Enter the correct Game ID",
            "ja": "正しいゲームIDを入力してください",
            "ko": "올바른 게임ID를 입력하세요",
            "ru": "Введите верный ID игрока",
            "zh-TW": "請輸入ID"
        },
        {
            "field1": "",
            "ID": "26",
            "zh-CN": "请输入兑换码",
            "field4": "错误提示",
            "field5": "35",
            "en": "Enter the correct Rewards Code",
            "ja": "正しい報酬コードを入力してください",
            "ko": "올바른 기프트코드를 입력하세요",
            "ru": "Введите верный наградной код",
            "zh-TW": "請輸入兌換碼"
        },
        {
            "field1": "",
            "ID": "27",
            "zh-CN": "请输入验证码",
            "field4": "错误提示",
            "field5": "35",
            "en": "Enter the correct Verification Code",
            "ja": "正しい確認コードを入力してください",
            "ko": "올바른 확인 코드를 입력하세요",
            "ru": "Введите верный код подтверждения",
            "zh-TW": "請輸入驗證碼"
        },
        {
            "field1": "",
            "ID": "28",
            "zh-CN": "请输入正确的邮箱",
            "field4": "错误提示",
            "field5": "30",
            "en": "Enter a valid email address",
            "ja": "有効なメールアドレスを入力してください",
            "ko": "올바른 이메일 주소를 입력하세요.",
            "ru": "Введите действующий эл. адрес",
            "zh-TW": "請輸入正確的郵箱"
        },
        {
            "field1": "",
            "ID": "29",
            "zh-CN": "请您输入正确的邮箱，否则将无法收到奖励兑换码",
            "field4": "说明",
            "field5": "60",
            "en": "To receive the reward, please enter a valid email address",
            "ja": "報酬を受け取るには、有効なメールアドレスを入力してください",
            "ko": "보상을 받으려면 올바른 이메일 주소를 입력하세요.",
            "ru": "Чтобы получить награду, введите действующий адрес эл. почты",
            "zh-TW": "請您輸入正確的郵箱，否則將無法收到獎勵兌換碼"
        },
        {
            "field1": "",
            "ID": "30",
            "zh-CN": "该福利仅可领取一次，不要错过！",
            "field4": "说明",
            "field5": "60",
            "en": "This reward can only be claimed once, don't miss out!",
            "ja": "この報酬を交換できるのは1回限りです。お見逃しなく！",
            "ko": "이 보상은 한 번만 받을 수 있으니 놓치지 마세요!",
            "ru": "Эту награду можно получить только один раз, не упустите!",
            "zh-TW": "該福利僅可領取一次，不要錯過哦！"
        },
        {
            "field1": "",
            "ID": "31",
            "zh-CN": "英文",
            "field4": "切换语言",
            "field5": "/",
            "en": "English",
            "ja": "English",
            "ko": "English",
            "ru": "English",
            "zh-TW": "English"
        },
        {
            "field1": "",
            "ID": "32",
            "zh-CN": "日语",
            "field4": "切换语言",
            "field5": "/",
            "en": "日本語",
            "ja": "日本語",
            "ko": "日本語",
            "ru": "日本語",
            "zh-TW": "日本語"
        },
        {
            "field1": "",
            "ID": "33",
            "zh-CN": "韩语",
            "field4": "切换语言",
            "field5": "/",
            "en": "한국어",
            "ja": "한국어",
            "ko": "한국어",
            "ru": "한국어",
            "zh-TW": "한국어"
        },
        {
            "field1": "",
            "ID": "34",
            "zh-CN": "俄语",
            "field4": "切换语言",
            "field5": "/",
            "en": "русский",
            "ja": "русский",
            "ko": "русский",
            "ru": "русский",
            "zh-TW": "русский"
        },
        {
            "field1": "",
            "ID": "35",
            "zh-CN": "繁体中文",
            "field4": "切换语言",
            "field5": "/",
            "en": "繁體中文",
            "ja": "繁體中文",
            "ko": "繁體中文",
            "ru": "繁體中文",
            "zh-TW": "繁體中文"
        },
        {
            "field1": "",
            "ID": "36",
            "zh-CN": "您确定使用此邮箱兑换奖励吗？",
            "field4": "",
            "field5": "",
            "en": "Are you sure to use this mailbox to redeem rewards?",
            "ja": "このメールの報酬コードの受け取りを確定しますか？",
            "ko": "이 우편함을 사용하여 보상을 받으시겠습니까?",
            "ru": "Подтверждаете получение кода вознаграждения для этого эл. адреса?",
            "zh-TW": "您確定使用此郵箱兌換獎勵嗎？"
        },
        {
            "field1": "",
            "ID": "37",
            "zh-CN": "兑换失败！参数错误。",
            "field4": "",
            "field5": "",
            "en": "Redeem failed; information incorrect",
            "ja": "交換に失敗しました：情報が誤っています",
            "ko": "교환 실패! 잘못된 정보",
            "ru": "Обменять не удалось; информация неверна",
            "zh-TW": "兌換失敗！參數錯誤。"
        },
        {
            "field1": "",
            "ID": "38",
            "zh-CN": "兑换失败！验证码有误。",
            "field4": "",
            "field5": "",
            "en": "Redeem failed; incorrect Verification Code",
            "ja": "交換に失敗しました：確認コードが誤っています",
            "ko": "교환 실패! 잘못된 확인 코드",
            "ru": "Обменять не удалось; неверный код подтверждения",
            "zh-TW": "兌換失敗！驗證碼有誤。"
        },
        {
            "field1": "",
            "ID": "39",
            "zh-CN": "服务器繁忙，请重试。",
            "field4": "",
            "field5": "",
            "en": "Server is busy, please try again.",
            "ja": "サーバーがビジー状態です。もう一度お試しください。",
            "ko": "서버 오류, 다시 시도해주세요.",
            "ru": "Сервер занят, попробуйте еще раз.",
            "zh-TW": "服務器繁忙，請重試。"
        },
        {
            "field1": "",
            "ID": "40",
            "zh-CN": "此邮箱已领取过奖励",
            "field4": "",
            "field5": "",
            "en": "You have already claimed rewards with this email.",
            "ja": "このメールの報酬をすでに受け取っています。",
            "ko": "이 이메일로 이미 보상을 받았습니다",
            "ru": "Вы уже забрали награды из этого письма.",
            "zh-TW": "此郵箱已領取過獎勵"
        },
        {
            "field1": "",
            "ID": "41",
            "zh-CN": "无效的邮箱地址",
            "field4": "",
            "field5": "",
            "en": "Invalid email address",
            "ja": "メールアドレスが無効です",
            "ko": "잘못된 이메일 주소",
            "ru": "Неверный адрес эл. почты",
            "zh-TW": "無效的郵箱地址"
        },
        {
            "field1": "",
            "ID": "42",
            "zh-CN": "恭喜您！成功领取奖励！",
            "field4": "",
            "field5": "",
            "en": "Congratulations! Rewards successfully claimed",
            "ja": "おめでとうございます！報酬を正常に受け取りました。",
            "ko": "축하합니다! 보상을 성공적으로 받았습니다!",
            "ru": "Поздравляем! Награды успешно получены.",
            "zh-TW": "恭喜您！成功領取獎勵！"
        },
        {
            "field1": "",
            "ID": "43",
            "zh-CN": "您兑换奖励的电子邮件地址是:",
            "field4": "",
            "field5": "",
            "en": "Your email address to redeem rewards is",
            "ja": "",
            "ko": "",
            "ru": "",
            "zh-TW": ""
        }
    ]



// WEBPACK FOOTER //
// ./src/tool/lang.js